/* projects/common-module/src/lib/app-components/auth-user-name/auth-user-name.component.scss */
.user {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}
.user__avatar {
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
  font-size: 1.1rem;
  font-weight: 600;
  line-height: 1;
  letter-spacing: 0.5px;
}
.user__avatar.user__avatar_supervised {
  background: var(--color-accent);
  color: var(--color-white);
}
.user__supervisor-icon {
  flex: none;
}
.user__name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/*# sourceMappingURL=auth-user-name.component.css.map */
